import _regeneratorRuntime from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/codebuild/output/src1688139503/src/cocoo_school_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.json.stringify.js";
// @ts-check
import moment from "moment";
import { useStore } from "vue2-helpers/vuex";
import { getData, downloadData } from "@/services/axios";
import { attendanceLabels } from "@/consts/attendanceLabels";
export var useDownloadAttendanceBook = function useDownloadAttendanceBook(filter, monthData, dailySummary, dailyEvents, students, classroom) {
  var store = useStore();
  var school = computed(function () {
    return store.state.school;
  });
  /** @type ComputedRef<string[]> */

  var holidays = computed(function () {
    return store.state.holidays;
  });

  var _useMonthlyYearlySumm = useMonthlyYearlySummary(monthData),
      schoolDayLength = _useMonthlyYearlySumm.schoolDayLength,
      getSummaryTemplate = _useMonthlyYearlySumm.getSummaryTemplate,
      aggregateStudentSummary = _useMonthlyYearlySumm.aggregateStudentSummary,
      aggregateMonthlyTypeSummary = _useMonthlyYearlySumm.aggregateMonthlyTypeSummary;

  var _storeToRefs = storeToRefs(useLoadingStore()),
      isLoading = _storeToRefs.isLoading;

  var localYearMonth = computed(function () {
    return moment(filter.yearMonth).format("YYYY年MM月");
  });

  var schoolDaysOfYearLength = function schoolDaysOfYearLength(schoolOffDaysOfYear) {
    var yearMonth = moment(filter.yearMonth).add(1, "month").startOf("month");
    return Object.keys(schoolOffDaysOfYear).filter(function (k) {
      return !schoolOffDaysOfYear[k] && yearMonth.isAfter(moment(k));
    }).length;
  };

  var schoolDaysOfYearBeforeTodayLength = function schoolDaysOfYearBeforeTodayLength(schoolOffDaysOfYear) {
    var yearMonth = moment(filter.yearMonth).add(1, "month").startOf("month");
    var today = moment();

    if (today.isBefore(yearMonth)) {
      return Object.keys(schoolOffDaysOfYear).filter(function (k) {
        return !schoolOffDaysOfYear[k] && today.isAfter(moment(k));
      }).length;
    } else {
      return Object.keys(schoolOffDaysOfYear).filter(function (k) {
        return !schoolOffDaysOfYear[k] && yearMonth.isAfter(moment(k));
      }).length;
    }
  };

  var downloadAttendanceBook = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var fiscalDate, data, fiscalYearDaysLength, schoolOffDaysOfYear, i, date, events, startOfMonth, endOfMonth, yearlySummaryByStudent, monthlyTypeSummaryByStudent, monthlyTable, monthlySummaryTable, yearlySummaryTable, studentNameTable, commentTable, monthlyTypeSummaryTable, dailySummaryTable, monthlyCalendar, schoolDayOffEventCalendar, filename;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              isLoading.value = true; // 今年度と来年度の初日を取得する

              fiscalDate = moment(filter.yearMonth).add(-3, "month").month(3).startOf("month");
              _context.next = 4;
              return getData(["reader/get_students_with_attendance?classroom_id=" + filter.classroomId + "&group_id=" + filter.groupId + "&fiscal_year=" + fiscalDate.year(), "events?orderby=updated_at&order=asc&classroom_id=" + filter.classroomId + "&fiscal_year=" + fiscalDate.year(), "attendance_monthly_comments?classroom_id=" + filter.classroomId + "&start_of_month=" + moment(filter.yearMonth).startOf("month").format("YYYY-MM-DD")]).catch(function (error) {
                console.log(error);
              });

            case 4:
              data = _context.sent;
              fiscalYearDaysLength = fiscalDate.clone().add(1, "years").diff(fiscalDate, "day");
              schoolOffDaysOfYear = {};

              for (i = 1; i <= fiscalYearDaysLength; i++) {
                date = fiscalDate.format("YYYY-MM-DD");

                if (fiscalDate.format("d") === "0" || fiscalDate.format("d") === "6" || holidays.value.includes(date)) {
                  schoolOffDaysOfYear[date] = true;
                } else {
                  schoolOffDaysOfYear[date] = false;
                }

                fiscalDate.add(1, "day");
              }

              events = data[1].items;
              events.forEach(function (v) {
                var from = moment(v.from);
                var to = moment(v.to);

                while (from.isSameOrBefore(to, "day")) {
                  schoolOffDaysOfYear[from.format("YYYY-MM-DD")] = Boolean(v.is_school_day_off);
                  from.add(1, "day");
                }
              });
              startOfMonth = moment(filter.yearMonth).startOf("month");
              endOfMonth = moment(filter.yearMonth).endOf("month");
              yearlySummaryByStudent = {};
              monthlyTypeSummaryByStudent = {};
              Object.keys(data[0].items).forEach(function (key) {
                data[0].items[key].forEach(function (student) {
                  var yearlySummary = getSummaryTemplate();
                  yearlySummary["要出席日数"] = schoolDaysOfYearLength(schoolOffDaysOfYear);
                  yearlySummary["出席日数"] = schoolDaysOfYearBeforeTodayLength(schoolOffDaysOfYear);
                  var monthlyTypeSummary = {};
                  student.attendance.forEach(function (v) {
                    if (schoolOffDaysOfYear[v.date]) {
                      return; // 休日のデータは無視する
                    }

                    if (!v.counting_type) {
                      return; // countingTypeがないときはSummaryに含めない
                    }

                    var countingType = v.counting_type.counting_type;

                    if (moment(v.date).isSameOrBefore(endOfMonth)) {
                      // year
                      aggregateStudentSummary(yearlySummary, countingType);

                      if (moment(v.date).isBetween(startOfMonth, endOfMonth, null, "[]")) {
                        aggregateMonthlyTypeSummary(v, monthlyTypeSummary);
                      }
                    }
                  });
                  yearlySummaryByStudent[student.id] = yearlySummary;
                  monthlyTypeSummaryByStudent[student.id] = monthlyTypeSummary;
                });
              });
              monthlyTable = [];
              monthlySummaryTable = [];
              yearlySummaryTable = [];
              studentNameTable = [];
              commentTable = [];
              monthlyTypeSummaryTable = [];
              students.forEach(function (v) {
                // 名前一覧
                studentNameTable.push([v.name]); // 月のテーブル

                var monthlyRow = [];
                monthData.forEach(function (v2) {
                  var k = Object.keys(v.attendanceByDate).find(function (k) {
                    return v2["YYYY-MM-DD"] === k;
                  });

                  if (k) {
                    var label = v.attendanceByDate[k].counting_type ? v.attendanceByDate[k].counting_type.glyph : attendanceLabels[v.attendanceByDate[k].type] ? attendanceLabels[v.attendanceByDate[k].type].code : null;
                    monthlyRow.push(label);
                  } else {
                    monthlyRow.push(null);
                  }
                });
                monthlyTable.push(monthlyRow); // 生徒ごとの欠席状況

                var m = v.monthlySummary;
                var y = yearlySummaryByStudent[v.id];
                monthlySummaryTable.push([m["停忌等"], m["要出席日数"], m["欠席（病気）"], m["欠席（事故）"], m["出席日数"], m["遅刻日数"], m["早退日数"]]);
                yearlySummaryTable.push([y["停忌等"], y["要出席日数"], y["欠席（病気）"], y["欠席（事故）"], y["出席日数"], y["遅刻日数"], y["早退日数"]]); // コメント

                var attendanceMonthlyComments = data[2].items;
                var comment = attendanceMonthlyComments.find(function (v2) {
                  return v.id === v2.student_id;
                });

                if (comment) {
                  commentTable.push([comment.comment]);
                } else {
                  commentTable.push([]);
                } // 生徒別のタイプ別合計


                var monthlyTypeSummary = Object.keys(monthlyTypeSummaryByStudent[v.id]).map(function (k) {
                  if (monthlyTypeSummaryByStudent[v.id][k]) {
                    return k + ":" + monthlyTypeSummaryByStudent[v.id][k];
                  }
                }).filter(function (v) {
                  return v;
                });
                monthlyTypeSummaryTable.push([monthlyTypeSummary.join("\n")]);
              }); // 毎日の合計

              dailySummaryTable = [];
              dailySummary.forEach(function (value) {
                var rowList = value.map(function (w, i) {
                  return monthData[i].isSchoolDayOff ? "-" : w;
                });
                dailySummaryTable.push(rowList);
              }); // 平日と休日を判別

              monthlyCalendar = monthData.map(function (v) {
                return !v.isSchoolDayOff;
              }); // イベント

              schoolDayOffEventCalendar = monthData.map(function (v) {
                if (v.isSchoolDayOff && dailyEvents[v["YYYY-MM-DD"]]) {
                  return dailyEvents[v["YYYY-MM-DD"]].filter(function (v2) {
                    return v2.is_school_day_off;
                  }).map(function (v2) {
                    return v2.title;
                  }).join(",");
                } else {
                  return "";
                }
              });
              filename = "COCOO月別カレンダー" + school.value.name + classroom.name + localYearMonth.value + "_" + moment().format("YYYYMMDDHHmmss") + ".xlsx";
              _context.next = 29;
              return downloadData("download_attendance_book?classroom_id=" + classroom.id + "&year_month=" + filter.yearMonth, {
                monthly_table: JSON.stringify(monthlyTable),
                daily_summary_table: JSON.stringify(dailySummaryTable),
                monthly_summary_table: JSON.stringify(monthlySummaryTable),
                yearly_summary_table: JSON.stringify(yearlySummaryTable),
                monthly_school_day_length: schoolDayLength.value,
                yearly_school_day_length: schoolDaysOfYearLength(schoolOffDaysOfYear),
                monthly_calendar: JSON.stringify(monthlyCalendar),
                student_name_table: JSON.stringify(studentNameTable),
                comment_table: JSON.stringify(commentTable),
                monthly_type_summary_table: JSON.stringify(monthlyTypeSummaryTable),
                school_day_off_event_calendar: JSON.stringify(schoolDayOffEventCalendar)
              }, filename).catch(function (error) {
                console.log(error);
              });

            case 29:
              isLoading.value = false;

            case 30:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function downloadAttendanceBook() {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    downloadAttendanceBook: downloadAttendanceBook
  };
};